<template>
  <Modal :id="id" title="Export Options" :width="300">
    <div slot="body" class="modal-body modal-form">
      <div class="row">
        <div class="col-12">
          <Field
            type="radio"
            name="export_option"
            id="export_option_all"
            label="All Pages"
            v-model="selectedExportOption"
            radio-value="all"
          />
        </div>
        <div class="col-12">
          <Field
            type="radio"
            name="export_option"
            id="export_option_current"
            label="Current Page Only"
            v-model="selectedExportOption"
            radio-value="current"
          />
        </div>
        <div class="col-12 mb-3">
          <Field
            type="radio"
            name="export_option"
            id="export_option_range"
            label="Page Range"
            v-model="selectedExportOption"
            radio-value="range"
          />
        </div>
        <div class="col-12">
          <div class="row no-gutters">
            <div class="col-4 page-input">
              <Field type="text" name="export_start_page" v-model="startPage" />
            </div>
            <div class="col-4 page-text pt-2">through</div>
            <div class="col-4 page-input">
              <Field type="text" name="export_end_page" v-model="endPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="modal-footer d-block text-center">
      <a class="btn btn-info" href="#" @click.prevent="submit">Export</a>
      <a class="btn btn-danger" href="#" @click.prevent="close">Cancel</a>
    </div>
  </Modal>
</template>

<script>
import ModalMixin from "mixins/Modal";
export default {
  mixins: [ModalMixin],
  data() {
    return {
      id: "export-modal",
      selectedExportOption: "all",
      startPage: null,
      endPage: null
    };
  },
  watch: {
    selectedExportOption(val) {
      if (val != "range") {
        this.startPage = null;
        this.endPage = null;
      }
    }
  },
  methods: {
    submit() {
      this.resolve({
        option: this.selectedExportOption,
        start: this.startPage,
        end: this.endPage
      });
    }
  }
};
</script>

<style scoped>
.page-text {
  color: #666666;
  font-size: 14px;
  text-align: center;
}
</style>